export const featuredPost = () => {
  const featuredPost = document.querySelectorAll('.featured-blog-post')
  if (featuredPost.length > 0) {
    featuredPost.forEach((item) => {
      const postId = item.dataset.id

      const blogCard = document.querySelectorAll(
        '.blog-results .blog-card-' + postId,
      )

      if (blogCard.length > 0) {
        blogCard[0].style.display = 'none'
      }
    })
  }
}
